/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Running_TitleInputs */

const cs_pm_running_title = /** @type {(inputs: Pm_Running_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`načítání a párování`)
};

const en_pm_running_title = /** @type {(inputs: Pm_Running_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`loading and matching`)
};

/**
* | output |
* | --- |
* | "loading and matching" |
*
* @param {Pm_Running_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_running_title = /** @type {((inputs?: Pm_Running_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Running_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_running_title(inputs)
	return cs_pm_running_title(inputs)
});